import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

function ClientDialog({ open, handleClose, handleOpenTwo, clients, selectedClient, handleClientSelectionChange, handleCancel }) {
    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md" sx={{ borderRadius: '12px' }}>
            <div className='dialog-header-container' style={{
                width: '95%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                height: '70px',
                padding: '0 16px',
                backgroundColor: '#f5f5f5',
                borderBottom: '1px solid #e0e0e0',
                borderRadius: '12px 12px 0 0'
            }}>
                <DialogTitle sx={{ fontSize: '1.25rem', fontWeight: '600', color: '#333' }}>
                    Clientes registrados
                </DialogTitle>
                <Button
                    variant='contained'
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={() => handleOpenTwo()}
                    sx={{
                        height: '40px',
                        backgroundColor: '#6200ea',
                        color: '#fff',
                        textTransform: 'none',
                        fontWeight: '500',
                        borderRadius: '8px',
                        '&:hover': { backgroundColor: '#3700b3' }
                    }}
                >
                    Agregar cliente
                </Button>
            </div>
            <DialogContent sx={{ padding: '16px', backgroundColor: '#fafafa' }}>
                <DataGrid
                    rows={clients}
                    columns={[
                        { field: 'clientID', headerName: 'ID', width: 70, headerClassName: 'data-grid-header' },
                        { field: 'clientName', headerName: 'Nombre', width: 150, headerClassName: 'data-grid-header' },
                        { field: 'clientEmail', headerName: 'Email', width: 150, headerClassName: 'data-grid-header' },
                        { field: 'cellphoneNumber', headerName: 'Celular', width: 100, headerClassName: 'data-grid-header' },
                        { field: 'phoneNumber', headerName: 'Teléfono', width: 100, headerClassName: 'data-grid-header' },
                        { field: 'address', headerName: 'Dirección', width: 200, headerClassName: 'data-grid-header' }
                    ]}
                    getRowId={(row) => row.clientID}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    onRowSelectionModelChange={(item) => handleClientSelectionChange(item)}
                    selectionModel={selectedClient ? [selectedClient.id] : []}
                    slots={{
                        toolbar: GridToolbar,
                    }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            sx: { padding: '8px', backgroundColor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }
                        }
                    }}
                    checkboxSelection
                    disableMultipleRowSelection
                    sx={{
                        border: 'none',
                        '& .MuiDataGrid-cell': { borderBottom: '1px solid #e0e0e0' },
                        '& .data-grid-header': { backgroundColor: '#f5f5f5', fontWeight: '600' }
                    }}
                />
            </DialogContent>
            <DialogActions sx={{ padding: '16px', backgroundColor: '#f5f5f5', borderTop: '1px solid #e0e0e0', borderRadius: '0 0 12px 12px' }}>
                <Button
                    onClick={handleCancel}
                    sx={{
                        color: '#ff0000',
                        textTransform: 'none',
                        fontWeight: '500',
                        borderRadius: '8px',
                        '&:hover': { backgroundColor: 'rgba(255, 0, 0, 0.1)' }
                    }}
                >
                    Cancelar
                </Button>
                <Button
                    onClick={handleClose}
                    disabled={!selectedClient?.clientName}
                    sx={{
                        backgroundColor: '#f759ab',
                        color: '#fff',
                        textTransform: 'none',
                        fontWeight: '500',
                        borderRadius: '8px',
                        '&:hover': { backgroundColor: '#eb2f96' },
                        '&:disabled': { backgroundColor: '#e0e0e0', color: '#a0a0a0' }
                    }}
                >
                    Seleccionar cliente
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ClientDialog